import React, { useEffect } from 'react';
import { appConfig } from '../../../settings';
import { IMyWindow } from '../../../interfaces';
import Styles from '../m_styles.less';

export const GoGetSslLogo: React.FC = () => {
    const { hostname } = window.location;
    const isLogoEnabled = hostname.includes(appConfig.defaultOCSHost);

    const stopScript = (): void => {
        const myWindow: IMyWindow = window;
        if (myWindow) {
            const script = document.getElementById('gogetssl-logo-js');
            script?.remove();
        }
    };
    const initScript = (): void => {
        stopScript();
        const myWindow: IMyWindow = window;
        if (myWindow) {
            const script = document.createElement('script');
            script.src = 'https://gogetssl-cdn.s3.eu-central-1.amazonaws.com/site-seals/gogetssl-seal.js';
            script.async = true;
            script.id = 'gogetssl-logo-js';
            document.body.appendChild(script);
        }
    };

    useEffect(() => {
        initScript();
        return (): void => {
            stopScript();
        };
    }, []);

    return isLogoEnabled ? (
        <>
            <div className={Styles.sslLogo}>
                <a href="https://www.gogetssl.com" rel="nofollow" title="GoGetSSL Site Seal Logo">
                    <div id="gogetssl-animated-seal" style={{ width: '110px', height: '35px' }}></div>
                </a>
            </div>
        </>
    ) : null;
};
